<template>
<div class="component">

    <div class="columns is-mobile is-multiline saleList">
        <div class=" column is-6-desktop is-12-tablet  is-12-mobile" v-for="sale in sales">
            <div class="saleItem">
                <div class="saleImage"> <img class="salePreviewImage" :src="getSaleImage(sale)" /></div>
                <div class="saleHeader">
                    <div class="saleTitle"> {{getSaleType(sale)}}: {{sale.title}}</div>
                    <div class="salePrice">{{getSalePrice(sale)}}</div>
                </div>
                <div class="saleDescription">{{sale.description}}</div>
                <div class="openSale"><span class="button is-medium is-info" @click="selectSale(sale)">Mehr Info</span></div>
            </div>
        </div>
    </div>

    <!--
    <div class="tile is-ancestor" v-for="salegroup in salesGroup">

        <div class="tile is-parent" v-for="sale in salegroup" v-if="sale!=undefined" @click="selectSale(sale)">
            <article :style="getRandomBackgroundClass()" class="tile is-child box">
                <div class="columns is-mobile is-multiline">
                    <div class="column is-12">
                        <p class="title is-size-1">{{sale.title}}</p>
                        <hr>
                    </div>
                </div>
                <p class="subtitle">Art: {{getSaleType(sale)}}</p>
                <div class="content">
                    <p>{{sale.description}}</p>
                </div>
            </article>
        </div>
    </div>
    -->
</div>
</template>

<script>
export default {
    name: 'salesList',
    props: [],
    mounted: function () {
        this.getSales();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            sales: [],
            selectedSale: "",
        }
    },
    methods: {
        getSales() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {}
            this.$axios.get(this.$backendURL + "/sales/get", {
                headers: headerData
            }).then(function (result) {
                this.sales = result.data.sales
            }.bind(this))
        },
        getSalePrice(sale) {
            if (sale.price != 0 && sale.price != undefined && sale.price != null) {
                return sale.price + ",00 €"
            } else if (sale.individual_reward != '' && sale.individual_reward != 0 && sale.individual_reward != undefined && sale.individual_reward != null) {
                return this.$t("enaq_translation_market_individual_price")
            } else if (sale.price == 0 && sale.price != undefined && sale.price != null) {
                return this.$t("enaq_translation_market_free")
            } {
                return this.$t("enaq_translation_market_no_price")
            }
        },

        selectSale(sale) {
            this.$emit("selected", sale)
        },

        getSaleImage(sale) {
            var imagePath = "/sales/"
            if (sale.images != null && sale.images.length > 0) {
                imagePath += sale.images[0].imagepath
            } else {
                imagePath += "default.png";
            }
            return this.$storageURL + imagePath;
        },
        getSaleType(sale) {
            switch (sale.type) {
                case 0:
                    return this.$t("enaq_translation_market_new_offer_type_sell");
                    break;
                case 1:
                    return this.$t("enaq_translation_market_new_offer_type_buy");
                    break;
                case 2:
                    return this.$t("enaq_translation_market_new_offer_type_trade");
                    break;
                case 3:
                    return this.$t("enaq_translation_market_new_offer_type_gift");
                    break;
                case 4:
                default:
                    return this.$t("enaq_translation_market_new_offer_type_other");
                    break;
            }
        },

    },
    computed: {

    },
}
</script>

<style scoped>
.saleItem {
    margin: 20px 10px;
    border: 3px solid #F0AD12;
    border-radius: 30px;
    overflow: hidden;
}

.saleHeader:after {
    content: "";
    border-bottom: 1px solid rgba(234, 172, 0, .6);
    width: 80%;
    display: inline-block;
}

.saleImage {
    background: rgba(234, 172, 0, .6);
    padding-top: 10px;
    height: 22vh;
    overflow: hidden;

}

.saleImage img {
    max-height: 20vh;
    min-height: 20vh;
    max-width: 90%;
    border-radius: 20px;
    border: 2px solid #f5f5f5;
}

.saleTitle {
    text-align: left;
    padding-left: 1em;
    font-size: 2em;
    font-weight: bolder;
    color: #F0AD12;
    display: inline-block;
    width: 70%;
    line-height: 2em;
    height: 2em;

}

.salePrice {
    display: inline-block;
    width: 20%;
    margin: 0 5%;
    background: #f5f5f5;
    border-radius: 20px;
    line-height: 2em;
    font-weight: bolder;
    height: 2em;
    cursor: default;
}

.openSale {
    padding: 20px;
}

.saleDescription {
    text-align: left;
    padding: 2%;
}

.enaqColorModal .modal-card {
    border: 5px solid #F80084;
    border-radius: 20px;
}

.enaqColorModal .modal-card-head {
    background: #FFC400;
    font-weight: bolder;
}

.is-child {
    cursor: pointer;
}
</style>
